import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import store from "./store";
import { Provider } from "react-redux";
// import { transitions, positions, Provider as AlertProvider } from 'react-alert'
// import AlertTemplate from 'react-alert-template-basic'
import * as Sentry from "@sentry/react";
import { registerLicense } from '@syncfusion/ej2-base';
const root = ReactDOM.createRoot(document.getElementById("root"));
// const options = {
//   // you can also just use 'bottom center'
//   position: positions.BOTTOM_CENTER,
//   timeout: 4000,
//   offset: "30px",
//   // you can also just use 'scale'
//   transition: transitions.SCALE,
// };
// registerLicense('Ngo9BigBOggjHTQxAR8/V1JEaF1cWWhBYVF0WmFZfVtgfV9HZlZSQmYuP1ZhSXxWdk1iXH9XcXJWQGlaVUZ9XEI=');
Sentry.init({
  dsn: "https://4b11e344ae2562b482c1ef0daac7973f@o4509248605061120.ingest.us.sentry.io/4509248606306304",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

root.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();